export default __webpack_public_path__ + "static/media/fon-top-content_2.d5d59336.png";